import instance from "@/services/apiService";
import apiUrls from "@/services/apiUrls";
import store from "@/store";

const cancelOnlinePayment = (payload) => {
  return instance.post(apiUrls.STRIPE_FAIL, payload);
};

const paymentIntent = (payload) => {
  return instance.post(apiUrls.PAYMENT_INTENT, payload);
};

const postPaymentSuccess = (payload) => {
  return instance.post(apiUrls.STRIPE_SUCCESS, payload);
};

const getSaveCards = () => {
  return instance.get(
    `${apiUrls.GET_CUSTOMER_SAVED_CARDS}?branchId=${store.getters.selectedBranch.id}`
  );
};

const deleteSavedCard = (payload) => {
  return instance.delete(
    `${apiUrls.GET_CUSTOMER_SAVED_CARDS}?cardID=${payload}&branchId=${store.getters.selectedBranch.id}`
  );
};

const setupIntent = (payload) => {
  return instance.post(apiUrls.STRIPE_SETUP_INTENT, payload);
};

export {
  cancelOnlinePayment,
  paymentIntent,
  postPaymentSuccess,
  getSaveCards,
  deleteSavedCard,
  setupIntent,
};
